var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73161 0.925003C4.9184 0.546592 5.45801 0.546592 5.64479 0.925003L6.7243 3.11196C6.79841 3.26209 6.94158 3.3662 7.10725 3.39042L9.52212 3.74339C9.93961 3.80441 10.106 4.31759 9.80376 4.61198L8.05717 6.31315C7.93707 6.43014 7.88225 6.59874 7.91059 6.76399L8.32268 9.16669C8.39402 9.58268 7.95737 9.89988 7.58382 9.70343L5.4252 8.56824C5.27684 8.49022 5.09957 8.49022 4.9512 8.56824L2.79259 9.70343C2.41903 9.89988 1.98238 9.58268 2.05373 9.16669L2.46582 6.76399C2.49416 6.59874 2.43934 6.43014 2.31924 6.31315L0.572649 4.61198C0.2704 4.31759 0.436794 3.80441 0.854283 3.74339L3.26916 3.39042C3.43483 3.3662 3.578 3.26209 3.65211 3.11196L4.73161 0.925003Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.96bae95239d8570109edee22de3d6a41.svg";
export { ForwardRef as ReactComponent };